import axiosAgent from './axiosAgent';
import ApiConfig from '../config/ApiConfig';

export const getIndividalSection = async (sectionId) => {
    const response = await axiosAgent.get(
        `${ApiConfig.section.getIndividalSection}/${sectionId}`
    );
    console.log('response of individualSection', response.data.data);
    return response.data?.data?.title || '';
};
